<div class="header-container">
  <div class="header-left">
    <div class="d-flex align-items-center">
      <mat-icon
        style="width: 44px; min-width: 44px; height: 44px; min-height: 44px; font-size: 44px; margin-right: 10px"
        color="primary">picture_as_pdf</mat-icon>
      <h2 class="mt-2 mb-0 text-secondary">
        {{ getTitle() }}
        @if (demandeDetails) {
        - {{ demandeDetails.emetteur?.nom }} {{ demandeDetails.emetteur?.prenom }}
        }
        @if (demandeRenouvellement) {
        - {{ demandeRenouvellement.emetteur.nom }} {{ demandeRenouvellement.emetteur.prenom }}
        }
      </h2>
    </div>
  </div>
  <div class="header-right">
    <div class="d-flex justify-content-end align-items-center gap-2">
      <!-- Navigation buttons -->
      @if (data.demandes.length) {
      <button mat-button class="mt-2" (click)="onPreviousPdf()" [disabled]="currentPdfIndex === 0" color="primary">
        <mat-icon>navigate_before</mat-icon>
      </button>
      <span class="pdf-counter">{{ currentPdfIndex + 1 }} / {{ data.demandes.length }}</span>
      <button mat-button class="mt-2" (click)="onNextPdf()" [disabled]="currentPdfIndex === data.demandes.length - 1"
        color="primary">
        <mat-icon>navigate_next</mat-icon>
      </button>
      }

      <!-- validate and refuse buttons -->
      <div class="d-flex justify-content-end align-items-center gap-2">
        @if (!isBulkMode && shouldShowRecallValidationButton() && data.action !== 'edit' && data.action !== 'advice') {
        <span class="divider"></span>
        <button mat-button class="mt-2 recall-btn d-flex align-items-center" (click)="onRecallValidation()">
          <mat-icon class="recall-icon me-1">change_circle</mat-icon>
          <span class="text-nowrap">Annuler la validation</span>
        </button>
        }
        @if (data.action === 'validate' || data.action === 'refuse' || data.action === 'review') {
        @if (shouldShowValidateButton()) {
        <span class="divider"></span>
        <button mat-button class="mt-2 validate-btn d-flex align-items-center" (click)="onValidate()">
          <mat-icon class="validate-icon me-1">check_circle</mat-icon>
          <span class="text-nowrap">{{ getValidateButtonText() }}</span>
        </button>
        }
        @if (canShowReject() && data.action !== 'validate') {
        <span class="divider"></span>
        <button mat-button class="mt-2 refuse-btn d-flex align-items-center" (click)="onRefuse()">
          <mat-icon class="refuse-icon me-1">cancel</mat-icon>
          <span class="text-nowrap">Refuser la demande</span>
        </button>
        }
        }
      </div>

      <!-- save and delete buttons -->
      @if (data.action === 'edit') {
      @if (currentStatus === StatusAvis.A_VALIDER || currentStatus === StatusAvis.A_VALIDER_N0) {
      <span class="divider"></span>
      <button mat-button class="mt-2 save-btn" color="primary" (click)="onSave()"><mat-icon>save</mat-icon>
        Enregistrer</button>
      <span class="divider"></span>
      <button mat-button class="mt-2 delete-btn" color="warn" (click)="onDelete()"><mat-icon>delete</mat-icon>
        Supprimer</button>
      }
      }

      <span class="divider"></span>
      @if (!isBulkMode && shouldShowRecallRefuseButton()) {
      <button mat-button class="mt-2 recall-btn d-flex align-items-center" (click)="onRecallRefuse()">
        <mat-icon class="recall-icon me-1">change_circle</mat-icon>
        <span class="text-nowrap">Annuler le refus</span>
      </button>
      <span class="divider"></span>
      }
      <!-- menu -->
      <button mat-button class="mt-2" color="primary" [matMenuTriggerFor]="menu">
        Plus d'action
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu xPosition="after" #menu="matMenu">
        @if (data.action === 'advice' && currentDemande?.flagDemandeAvis && currentDemande?.canAnswerAvis) {
        <button mat-menu-item (click)="answerAdvice()">
          <mat-icon>comment</mat-icon>
          <span>Répondre à {{ demandeurAvis }}</span>
        </button>
        }
        @if (
        (data.action === 'validate' || data.action === 'refuse' || data.action === 'review') &&
        currentDemande?.flagDemandeAvis &&
        currentDemande?.canDeleteAvis
        ) {
        <button mat-menu-item (click)="cancelAdvice()">
          <mat-icon>cancel</mat-icon>
          <span>Annuler demande d'avis</span>
        </button>
        }
        @if (isBulkMode && shouldShowRecallValidationButton()) {
        <button mat-menu-item (click)="onRecallValidation()">
          <mat-icon class="recall-icon">change_circle</mat-icon>
          <span>Annuler la validation</span>
        </button>
        }
        @if (isBulkMode && shouldShowRecallRefuseButton()) {
        <button mat-menu-item (click)="onRecallRefuse()">
          <mat-icon class="recall-icon">change_circle</mat-icon>
          <span>Annuler le refus</span>
        </button>
        }
        @if (shouldShowAskAdviceButton()) {
        <button mat-menu-item (click)="getAdvices()">
          <mat-icon>question_mark</mat-icon>
          <span>Demande d'avis</span>
        </button>
        }
        <button mat-menu-item (click)="deplierPanels()">
          <mat-icon>unfold_more</mat-icon>
          <span>Déplier tous les volets</span>
        </button>
        <button mat-menu-item (click)="replierPanels()">
          <mat-icon>unfold_less</mat-icon>
          <span>Replier tous les volets</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="onDownload()">
          <mat-icon>download</mat-icon>
          <span>Télécharger</span>
        </button>
        <button mat-menu-item (click)="onPrint()">
          <mat-icon>print</mat-icon>
          <span>Imprimer</span>
        </button>
      </mat-menu>
      <span class="divider"></span>

      <div class="toggle-container d-flex align-items-center gap-2">
        <span class="toggle-label">{{ isOpened ? 'Masquer détails' : 'Voir les détails' }}</span>
        <mat-slide-toggle color="basic" class="mt-2" [checked]="isOpened" (change)="OnToggleChange($event.checked)">
        </mat-slide-toggle>
      </div>

      <button mat-button class="mt-2" color="primary" (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>

<mat-sidenav-container class="full-container">
  <!-- for details -->
  <mat-sidenav [opened]="isOpened" style="width: 55% !important" #sidenav [mode]="'side'" [position]="'end'">
    @if (currentDemandeType === DemandeType.Recrutement) {
    @if (demandeDetails) {
    <app-demande-recrutement-form [demandeDetails]="demandeDetails" [readOnly]="isReadOnly"
      [viewMode]="data.action"></app-demande-recrutement-form>
    }
    }
    @if (currentDemandeType === DemandeType.Renouvellement) {
    @if (demandeRenouvellement) {
    <app-demande-renouvellement-form [demandeDetails]="demandeRenouvellement" [readOnly]="isReadOnly"
      [viewMode]="data.action"></app-demande-renouvellement-form>
    }
    }
  </mat-sidenav>

  <!-- for pdf -->
  <mat-sidenav-content>
    <div class="p-0">
      <pdf-viewer #pdfViewer [src]="pdfSource" class="pdfViewer" [show-borders]="true" [render-text]="isReadOnly"
        [original-size]="false" [zoom]="pmdfZoomFactor" [show-all]="true">
      </pdf-viewer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>